module.exports = __webpack_public_path__ + "img/vedio.593c84ab.png";